import { format, parse } from "date-fns";

export function useBlogPostPublishDate() {
  return (date: string) => format(
    parse(date, "yyyy-MM-dd", new Date()),
    "MMMM d, yyyy"
  );
}